import { useEffect } from 'react';

/**
 * Fix para bug conhecido do Radix UI: ao fechar um Select dentro de um Dialog,
 * o body fica com pointer-events:none, travando toda a UI.
 * https://github.com/radix-ui/primitives/issues/1241
 */
export function useRadixPointerEventsFix() {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (document.body.style.pointerEvents === 'none') {
        // Se nenhum portal Radix ativo exige bloqueio, libera
        const hasOpenOverlay = document.querySelector(
          '[data-radix-popper-content-wrapper], [data-state="open"][role="dialog"]'
        );
        if (!hasOpenOverlay) {
          document.body.style.pointerEvents = '';
        }
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

    const clear = () => {
      setTimeout(() => {
        if (document.body.style.pointerEvents === 'none') {
          document.body.style.pointerEvents = '';
        }
      }, 100);
    };
    document.addEventListener('pointerup', clear);
    document.addEventListener('click', clear);

    return () => {
      observer.disconnect();
      document.removeEventListener('pointerup', clear);
      document.removeEventListener('click', clear);
    };
  }, []);
}
